const data = [
  {
    name: "Breadcrumbs",
    hasLargerMdPaddingTop: false,
    hasSideNavColumnOffset: false,
    customColumn: "offset-lg-3 col",
    hasHighContrastBorderTop: true,
    data: {
      pt: [
        { text: "UA", url: "/" },
        { text: "deca", url: "/deca" },
        { text: "cursos", url: "/cursos" }
      ],
      en: [
        { text: "UA", url: "/" },
        { text: "deca", url: "/deca" },
        { text: "courses", url: "/courses" }
      ]
    }
  },
  {
    name: "SubWebDepartmentCourses"
  }
];

export default data;
